/*-----------------------------------------------------------------
- Components translations
-----------------------------------------------------------------*/

export default {
    uploader: {
        drag: {
            single  : 'فایل خود را اینجا رها کنید!',
            multiple: 'فایل‌های خود را اینجا رها کنید!',
        },

        button: {
            small   : 'انتخاب فایل',
            single  : 'یا فایل خود را انتخاب کنید',
            multiple: 'یا فایل‌های خود را انتخاب کنید',
        },

        add                         : 'پیدا کردن فایل',
        dictRemoveFile              : 'حذف فایل',
        dictRemoveFileConfirmation  : 'آیا از حذف فایل اطمینان دارید؟',
        dictCancelUpload            : 'بی‌خیال!',
        dictUploadCanceled          : 'فرایند آپلود متوقف شد!',
        dictCancelUploadConfirmation: 'آیا از متوقف کردن فرایند آپلود اطمینان دارید؟',
        dictFileTooBig              : 'حجم فایل زیاد است ({filesize} مگابایت). حداکثر حجم فایل قابل ارسال {maxFileSize} مگابایت است.',
        dictInvalidFileType         : 'امکان آپلود فایل با این فرمت وجود ندارد.',
        dictResponseError           : 'اختلال در برقراری ارتباط.',
        dictMaxFilesExceeded        : 'نمی‌توانید بیش از {maxFiles} فایل آپلود کنید.',

        size          : 'مگابایت',
        uploading     : 'فایل شما در حال بارگذاری است.',
        stop_uploading: 'توقف بارگذاری',
    },

    date_picker: {
        addon: {
            date    : 'تاریخ',
            time    : 'زمان',
            datetime: 'تاریخ',
            year    : 'سال',
            month   : 'ماه',
        },
    },
};
